import { createFileRoute } from '@tanstack/react-router'

import { EditInvoicePage } from '@/pages/invoices/[id]/edit/EditInvoicePage'

export const Route = createFileRoute('/_authenticated/_dashboard/invoices/$id/edit/')({
  component: EditInvoicePage,
})
